import React from 'react';
import { useTranslation } from 'react-i18next';

import { NS_COMMON } from '../../../../../../../services/i18n/namespaces';
import { ReadOnlyCellTextField } from '../ReadOnlyCellTextField/ReadOnlyCellTextField';

import { ORIGINATING_SOURCE_TRANSLATION_KEYS } from './constants';
import { formatValueHistoryDate } from './service';

export { formatValueHistoryDate };

export function ValueHistoryDateCell({ value }) {
  return <ReadOnlyCellTextField value={formatValueHistoryDate(value)} />;
}

export function OriginatingSourceCell({ value }) {
  const { t } = useTranslation();

  const translationKey = ORIGINATING_SOURCE_TRANSLATION_KEYS[value];
  const label = translationKey ? t(`${NS_COMMON}:${translationKey}`) : '';

  return <ReadOnlyCellTextField value={label} />;
}
